'use strict';

class SubscriptionsEditController {
  constructor($log,
              $q,
              $rootScope,
              $scope,
              $filter,
              $state,
              utils,
              config,
              SubscriptionsService,
              UsersService,
              PermissionsService,
              LocationsService,
              OrganizationService,
              ToastsService) {

    // region Define Fields

    const $t = $filter('translate');
    const CURRENT_ADMIN_LOCAL_STORAGE_KEY = 'App-Admin';
    const SELECTED_SUBSCRIPTION_LOCAL_STORAGE_KEY = 'Selected-Subscription';
    const ALL_ORGS_LOCAL_STORAGE_KEY = 'Organizations-All';
    const SELECTED_USER_LOCAL_STORAGE_KEY = 'Selected-User';
    const SELECTED_LOCATION_LOCAL_STORAGE_KEY = 'Selected-Location';

    const allOrganizations = utils.getStorageItem(ALL_ORGS_LOCAL_STORAGE_KEY);

    let userPlanId = $state.params && $state.params.userPlanId;
    let userId = $state.params && $state.params.userId;
    let locationId = $state.params && $state.params.locationId;
    let transactionsLoaded = false;

    $scope.isReadOnlyMode = true;
    $scope.userId = parseInt(userId);
    $scope.locationId = parseInt(locationId);
    $scope.userPlanId = parseInt(userPlanId);
    $scope.dateFormat = $t('datetime.mdyHM12');
    $scope.subscription = utils.getStorageItem(SELECTED_SUBSCRIPTION_LOCAL_STORAGE_KEY);

    // Check for paid admin permissions
    $scope.userInfo = utils.getStorageItem(CURRENT_ADMIN_LOCAL_STORAGE_KEY);
    $scope.isPaidAdmin = PermissionsService.isPaidAdmin();
    $scope.isServiceAdmin = PermissionsService.isServiceAdmin();

    // If the stored subscription doesn't correspond to the url parameter userPlanId (means - we better get the subscription from API)
    if ($scope.userPlanId !== $scope.subscription.userPlanId) {
      $scope.subscription = null;
    }

    // Where we came from to this page (view)
    $scope.selection = ($state.params && $state.params.from) || 'user';
    $scope.subscriptionStatuses = config.getConfigByKey('subscriptionStatuses');
    $scope.upgradePlans = [];

    const paymentTypes = config.getConfigByKey('paymentTypes');
    const subscriptionTypes = config.getConfigByKey('subscriptionTypes');

    // Navigaiton Tabs
    $scope.tabs = [
      {
        id: 'details',
        name: $t('form.details'),
        icon: 'far fa-file-alt'
      }, {
        id: 'relations',
        name: $t('bots.relations'),
        icon: 'far fa-link'
      },
      {
        id: 'history',
        name: $t('common.history'),
        icon: 'far fa-history'
      }
    ];

    // endregion

    // Put on scope only the stuff we really need there
    angular.extend($scope, {
      viewUser: viewUser,
      revoke: revoke,
      update: update,
      back: back,

      // Subscriptions & Services
      getServiceAttachment: getServiceAttachment,
      getPaymentType: getPaymentType,
      getSubscriptionType: getSubscriptionType,
      openBilling: openBilling,
      openUpgradeModal: openUpgradeModal,
      canUpgradeSubscription: canUpgradeSubscription,
      canDeleteSubscription: canDeleteSubscription,
      upgradeSubscription: upgradeSubscription,

      // Relations
      generateAddress: generateAddress,
      viewLocation: viewLocation
    });

    // region Methods

    function back() {
      $scope.loading = false;
      if ($scope.selection === 'user') {
        $state.go('main.users.edit', { tab: 'subscriptions', userId: $scope.userId });
        $rootScope.$emit('refreshChooseMenuEvent', 'users');
      } else if ($scope.selection === 'location') {
        $state.go('main.locations.edit', { tab: 'subscriptions', locationId: $scope.locationId });
        $rootScope.$emit('refreshChooseMenuEvent', 'locations');
      } else {
        $state.go('main.users.list');
        $rootScope.$emit('refreshChooseMenuEvent', 'users');
      }
    }

    function initPage() {
      $scope.loading = true; // To indicate subscription info is being loaded

      $scope.$watch('activeTab', function(newValue, oldValue) {
        switch (newValue) {
          case 'history':
            if (!transactionsLoaded) {
              getSubscriptionHistory();
            }
            break;
        }
      });

      getSubscription()
        .then(subscription => {
          $scope.subscription = subscription;

          // Get user who paid for subscription
          if (subscription.userId) {
            getUser(subscription.userId);
          }

          // Get Location Info
          if (subscription.locationId || locationId) {
            let getBilling = subscription.billingSystem ? false : true;
            getLocation(getBilling);
          }

          // Subscription status
          $scope.subscriptionStatus = $t('subscriptions.free');
          $scope.subscriptionStatusColor = 'grey';
          $scope.subscriptionStatusText = $t('subscriptions.freeDesc');
          if (subscription.cancelled) {
            $scope.subscriptionStatus = $t('subscriptions.cancelledTag');
            $scope.subscriptionStatusText = $t('subscriptions.cancelledDesc', { date: $filter('date')($scope.subscription.cancelDateMs, $scope.dateFormat) });
          } else {
            if (subscription.status === 0) {
              if (subscription.subscriptionId) {
                $scope.subscriptionStatus = $t('subscriptions.purchasedTag');
                $scope.subscriptionStatusColor = 'green';
                $scope.subscriptionStatusText = $t('subscriptions.purchasedDesc', { date: $filter('date')($scope.subscription.issueDateMs, $scope.dateFormat) });
              }
            } else if (subscription.status === 2) {
              $scope.subscriptionStatus = $t('subscriptions.paused');
              $scope.subscriptionStatusText = $t('subscriptions.freeDesc');
              if (!subscription.plan?.freemium) {
                $scope.subscriptionStatusText = $t('subscriptions.assigned') + ' ' + $filter('date')($scope.subscription.issueDateMs, $scope.dateFormat);
              }
            } else {
              $scope.subscriptionStatus = $t('subscriptions.expiredTag');
              $scope.subscriptionStatusColor = 'red';
              $scope.subscriptionStatusText = $t('subscriptions.expiredDesc', { date: $filter('date')($scope.subscription.endDateMs, $scope.dateFormat) });
            }
          }

        })
        .then(() => $scope.loading = false)
        .catch(err => {
          $scope.loading = false;
          $scope.thereAreMoreItems = false;
          utils.handleApiError(err);
          return $q.reject(err);
        });
    }

    function getSubscriptionHistory(subscription) {
      $scope.historyLoading = true;
      return SubscriptionsService.getSubscriptionTransactions($scope.userPlanId, $scope.locationId)
        .then(history => {
          $scope.subscriptionHistory = history.transactions || [];
          $scope.subscriptionChangesHistory = $scope.subscriptionHistory.filter(t => !!t.prevPriceId);

          if ($scope.subscription) {
            for (let i = 0; i < $scope.subscriptionHistory.length; i++) {
              $scope.subscriptionHistory[i].paymentType = $scope.subscription.paymentType;
              $scope.subscriptionHistory[i].sandbox = $scope.subscription.sandbox;
            }
          }
          $scope.historyLoading = false;
          transactionsLoaded = true;
          return $scope.subscriptionHistory;
        }, err => {
          $scope.historyLoading = false;
          utils.handleApiError(err);
        });
    }

    function getSubscription(reload) {
      if (!reload && $scope.subscription) {
        return $q.resolve($scope.subscription); // In case we have already cached subscription
      }

      if ($scope.userId) {
        return SubscriptionsService.getUserSubscriptions($scope.userId, void 0, $scope.userPlanId, true)
          .then(userSubscriptionsData => {
            let userSubscriptions = userSubscriptionsData.subscriptions || [];
            return userSubscriptions.find(s => s.userPlanId === $scope.userPlanId);
          }, err => utils.handleApiError(err));
      } else {
        return SubscriptionsService.getLocationSubscriptions($scope.locationId, void 0, $scope.userPlanId, true)
          .then(locationSubscriptionsData => {
            let locationSubscriptions = locationSubscriptionsData.subscriptions || [];
            return locationSubscriptions.find(s => s.userPlanId === $scope.userPlanId);
          }, err => utils.handleApiError(err));
      }

    }

    function getServiceAttachment(service) {
      if (service.resourceType === 'undefined') {
        return $t('common.unknown');
      }

      let result = $t('subscriptions.resource-types.' + service.resourceType);
      if (service.resourceId) {
        result += ' #' + service.resourceId;
        // Only DeviceFileSpace attached to specific user
      } else if (service.name === 'DeviceFileSpace' && service.resourceType === 0 && ($scope.subscription.userId || $scope.userId)) {
        result += ' #' + $scope.subscription.userId || $scope.userId;
      } else if (service.resourceType === 1 && ($scope.subscription.locationId || $scope.locationId)) {
        result += ' #' + $scope.subscription.locationId || $scope.locationId;
      }

      return result;
    }

    function getPaymentType(type) {
      let unknownType = $t('subscriptions.unknownPaymentType');
      if (typeof type !== 'number') {
        return unknownType;
      }
      let result = paymentTypes.find(el => el.id === type);
      if (!result) {
        return unknownType;
      }
      return $t(result.name);
    }

    function getSubscriptionType(type) {
      let unknownType = {
        name: $t('subscriptions.unknownType'),
        icon: 'question'
      };
      if (typeof type !== 'number') {
        return unknownType;
      }
      let result = subscriptionTypes.find(el => el.id === type);
      if (!result) {
        return unknownType;
      }
      return result;
    }

    // Open related billing in new tab
    function openBilling() {
      if ($scope.subscription.subscriptionId && $scope.subscription.paymentType === $scope.subscription.billingSystem.id) {
        let redirectPath = $scope.subscription.sandbox && $scope.subscription.billingSystem.sandbox ? 'sboxUrl' : 'url';
        window.open($scope.subscription.billingSystem[redirectPath] + $scope.subscription.subscriptionId, '_blank');
        return;
      }
      ToastsService.error($t('subscriptions.billingError'));
    }

    function getUpgradePlans() {
      if ($scope.subscription.status !== 0 || $scope.subscription.updatePlan || !$scope.subscription.upgradableTo || $scope.subscription.upgradableTo.length === 0) {
        $scope.loading = false;
        return;
      }

      let params = {
        locationId: $scope.subscription.locationId || $scope.locationId,
        organizationId: $scope.location.organizationId
      };

      // Upgradable only to related type of service plan
      if ($scope.subscription.plan.appName) {
        // Get service plans for specified appName
        return SubscriptionsService.getAllServicePlans(params.locationId, void 0, void 0, $scope.subscription.plan.appName, false)
          .then(paidPlansData => {
            return processSubscriptions(paidPlansData.servicePlans || []);
          }, err => {
            $scope.loading = false;
            utils.handleApiError(err);
          });
      } else {
        // Get service plans that are available to be assigned within current Organization
        return SubscriptionsService.getAllServicePlans(params.locationId, void 0, params.organizationId, void 0, false)
          .then(freePlansData => {
            return processSubscriptions(freePlansData.servicePlans || []);
          }, err => {
            $scope.loading = false;
            utils.handleApiError(err);
          });
      }
    }

    /* Set plans available to upgrade to */
    function processSubscriptions(plans) {
      if (!plans || plans.length === 0) {
        $scope.loading = false;
        return;
      }
      $scope.loading = false;
      $scope.upgradePlans = plans
        .filter(plan => !!plan.available && $scope.subscription.upgradableTo?.some(item => item === plan.id));
    }

    function canUpgradeSubscription() {
      if ($scope.subscription.updatePlan) {
        return false;
      }
      return PermissionsService.canIUpgradeSubscription();
    }

    function canDeleteSubscription() {
      return PermissionsService.canIDeleteSubscription($scope.subscription);
    }

    function getSalesTaxRate() {
      if ($scope.location && $scope.location.salesTaxRate) {
        return parseFloat($locationEditPage.locationInfo.salesTaxRate);
      }
      return null;
    }

    function openUpgradeModal() {
      $scope.targetPlanId = $scope.upgradePlans[0].id;
      $('#upgrade-subscription-modal')
        .modal({
          autofocus: false,
          closable: true,
          detachable: true
        })
        .modal('show');
    }

    function upgradeSubscription() {
      $('#upgrade-subscription-modal').modal('hide');
      if (!$scope.targetPlan) {
        ToastsService.error($t('subscriptions.no-subscription-update-available'));
        return; // do nothing
      }

      $scope.loading = true;
      return SubscriptionsService.upgradeUserSubscription(
        $scope.userPlanId,
        $scope.targetPlan.id,
        $scope.subscription.userId || void 0)
        .then(() => {
          ToastsService.success();
          transactionsLoaded = false;

          // Reload subscription
          getSubscription(true)
            .then(subscription => {
              $scope.subscription = subscription;
              $scope.loading = false;
              return getUpgradePlans();
            }).catch(err => {
            $scope.loading = false;
            utils.handleApiError(err);
          });

        }, err => {
          $scope.loading = false;
          utils.handleApiError(err);
        });
    }

    // endregion

    function getUser(userId) {
      let userInfo = utils.getStorageItem(SELECTED_USER_LOCAL_STORAGE_KEY);
      if ($scope.selection === 'user' && userInfo) {
        $scope.user = userInfo;
        return;
      }

      return UsersService.getUserInfo(userId)
        .then(data => {
          $scope.user = data.user;
        }, err => utils.handleApiError(err));
    }

    function getLocation(getBilling) {
      let locationInfo = utils.getStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY);
      if ($scope.selection === 'location' && locationInfo) {
        $scope.location = locationInfo;
        if (getBilling) {
          getOrganizationProps($scope.location.organizationId);
        }
        return getUpgradePlans();
      }

      return LocationsService.getLocationInfo(void 0, $scope.locationId || $scope.subscription.locationId)
        .then(data => {
          if (data && data.locations && data.locations.length) {
            $scope.location = data.locations.find(l => l.id === $scope.locationId || $scope.subscription.locationId);
            if (getBilling) {
              getOrganizationProps($scope.location.organizationId);
            }
            return getUpgradePlans();
          }
        }, err => utils.handleApiError(err));
    }

    function generateAddress(location) {
      let address = utils.generateAddress(location);
      if (!address) {
        return $t('common.unknown-address');
      }
      return address;
    }

    // Getting billing system organizational objects
    function getOrganizationProps(organizationId) {
      OrganizationService.getObjectsAndProperties(organizationId)
        .then(result => {
          if (result && result.organizationObjects && result.organizationObjects.length > 0) {
            $scope.subscription.billingSystem = utils.generateBillingPath(result.organizationObjects);
          }
        });
    }

    function revoke() {
      $('#subscription-revoke-dialog')
        .modal({
          closable: false,
          detachable: true,
          onApprove: () => revokeInternal()
        })
        .modal('show');
    }

    function update() {
      return SubscriptionsService.updatePurchaseInfo($scope.userPlanId, $scope.subscription.locationId, $scope.userId, $scope.subscriptionId)
        .then(() => back(), err => {
          $scope.loading = false;
          $scope.thereAreMoreItems = false;
          utils.handleApiError(err);
        });
    }

    function revokeInternal() {
      $scope.loading = true;
      return SubscriptionsService.cancelSubscription($scope.userPlanId, $scope.subscription.locationId)
        .then(() => back(), err => {
          $scope.loading = false;
          $scope.thereAreMoreItems = false;
          utils.handleApiError(err);
        });
    }

    function viewUser() {
      if ($scope.selection === 'user') {
        return back();
      }

      $scope.loading = false;
      utils.setStorageItem(SELECTED_USER_LOCAL_STORAGE_KEY, $scope.user);
      $state.go('main.users.edit', {
        tab: 'status'
      });
      $rootScope.$emit('refreshChooseMenuEvent', 'users');
    }

    function viewLocation() {
      if ($scope.selection === 'location') {
        return back();
      }

      $scope.loading = false;
      utils.setStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY, $scope.location);
      $state.go('main.locations.edit');
    }

    // endregion

    initPage();

    $scope.$on('$destroy', () => {
      $('#subscription-revoke-dialog').remove();
      $('#upgrade-subscription-modal').remove();
    });

  }
}

export default angular
  .module('main.subscriptionsEdit.controller', [])
  .controller('SubscriptionsEditController', SubscriptionsEditController)
  .name;
